import ReactDOM from 'react-dom';
import React from 'react';
import RegionalLogos from 'root/main/components/regionalLogos/RegionalLogos';

export default function () {
    const rootEls = document.querySelectorAll(
        '[data-react=regionalLogos]'
    ) as NodeListOf<HTMLElement>;
    rootEls.forEach(root => {
        ReactDOM.render(
            <RegionalLogos reactRegionalLogos={root.dataset.reactRegionalLogos} />,
            root
        );
    });
}
